// extracted by mini-css-extract-plugin
module.exports = {"edit":"edit--2GT3y","btns":"btns--3cfB-","saveBtn":"saveBtn--1aohD","boxTitle":"boxTitle--2r4sq","info":"info--3Y8Ax","high":"high--E-L7r","editor":"editor--3P5hm"};